import React from 'react';
import { Row, Col } from 'antd';
import image1 from '../../assets/meth-1.jpg';
import image2 from '../../assets/meth-2.jpg';
import image3 from '../../assets/meth-3.jpg';

const intl = {
  block1: {
    'en': <div style={{ fontSize: '14px', lineHeight: 1.2 }}>
      <h3 style={{ color: '#fff', fontWeight: 700 }}>Diagnostics</h3>
      Organizations are often compared to living organisms, adapting to and affected by events.
      <br /><br />
      No matter the size, any event can have far-reaching consequences – leadership changes, financial crashes, mergers and acquisitions, new clients. Which is why it is essential to have an understanding of your organizational parameters and the potential impact of such events.
      <br /><br />
      Organizational diagnostics involve an assessment of your organization’s current health. They identify strengths and weaknesses in relation to organizational culture, leadership, communication and ability to change.
    </div>,
    'dk': <div style={{ fontSize: '14px', lineHeight: 1.2 }}>
      <h3 style={{ color: '#fff', fontWeight: 700 }}>Diagnosticering</h3>
      Organisationer sammenlignes ofte med levende organismer. En organisme hvis livsvilkår påvirkes af begivenheder og forandringer omkring den. Det kan være små eller større begivenheder med vidtrækkende konsekvenser.
    <br /><br />
      F.eks. i forbindelse med køb eller salg af virksomhed. Her vil det især være hensigtsmæssigt at lave en analyse af organisatoriske parametre, der ikke er specifikt økonomiske, men som er afgørende for virksomhedens evne til at fastholde eller øge resultaterne. Det kunne være kommunikation og ledelse, som udtryk for en sund kultur. De er nemlig afgørende for hvorvidt et køb eller salg bliver en succes.
    <br /><br />
      Organisationsdiagnosticering er en metode til at analysere og forstå en organisationssammensætning og det relationelle samspil mellem dens aktører udtrykt gennem kulturen, kommunikation og ledelsens evne til at skabe forandringer.
  </div>,
  },
  block2: {
    'en': <div style={{ fontSize: '14px', lineHeight: 1.2 }}>
      <h3 style={{ color: '#fff', fontWeight: 700 }}>Systems and Culture</h3>
      Culture can be described in global, national, organizational, familial and personal terms. Culture reflects our values and values in turn define our behavior. In an organization, this has an effect on how we interact with colleagues and customers. Values relate not to what say you but to what you do.
      <br /><br />
      A truly healthy culture can be summarized in the phrase, ‘Say what you do – and do what you say – with respect for the individual, the organization and the task!‘ Simple yet difficult.
      <br /><br />
      Systems are necessary to guide us in utilizing the resources in the most appropriate manner. Unfortunately, that also means that systems sometimes prevent us from delivering or stifle our creativity. This happens when systems themselves become the goal rather than the solution.
      <br /><br />
      We help organizations get a clear handle on this, and demand continuous improvement of ourselves, our partners and our clients.
    </div>,
    'dk': <div style={{ fontSize: '14px', lineHeight: 1.2 }}>
      <h3 style={{ color: '#fff', fontWeight: 700 }}>Systemer og kultur</h3>
      Kultur i organisationer kan beskrives på mange måder. Kultur definerer handlingsrum og er det adfærdsmæssige udtryk for organisationens værdier. Det er hvordan organisationens medlemmer indgår i- og skaber relationer med hinanden og deres kunder. Værdier er ikke hvad man siger eller skriver – det er hvad man gør.
    <br /><br />
      En sund kultur kan opsummeres i ‘sig hvad du gør – og gør hvad du siger – med respekt for individ, opgave og organisation!‘ Enkelt men svært. Systemer er nødvendige for at hjælpe os med at styre ressourcerne mest optimalt. Det betyder at de også nogle gange bliver bremsende for opgaveløsningen eller vores kreativitet. Det sker når systemer bliver formål mere end midlet.
    <br /><br />
      Det hjælper vi organisationer med at få styr på og forventer kontinuerlig forbedring - af os selv, af vores partnere og vores klienter.
  </div>,
  },
  block3: {
    'en': <div style={{ fontSize: '14px', lineHeight: 1.2 }}>
      <h3 style={{ color: '#fff', fontWeight: 700 }}>Relationships</h3>
      Work is by nature collaborative. Even when you fulfill a task alone it is always part of something bigger. Relationships and dialogue are essential to a healthy organization. They are built on a foundation of trust, genuine interest, absence of prejudice and honest curiosity. Good work relationships enable a healthy feedback culture, sustain a learning environment and contribute to continuous performance improvement.
    </div>,
    'dk': <div style={{ fontSize: '14px', lineHeight: 1.2 }}>
      <h3 style={{ color: '#fff', fontWeight: 700 }}>Relationer</h3>
      Ingen løser opgaver alene. Alle indgår i relationer med andre og dialog er et nødvendigt udgangspunkt for alle sunde relationer. Grundlaget er tillid og de bærende byggesten er ægte interesse, fravær af fordomme og nysgerrighed. Gode arbejdsmæssige relationer er nødvendige for at arbejde sammen og levere resultater.
  Derudover er evnen til at give og modtage feedback essentiel for kontinuerlig udvikling og forbedring af resultater.
    </div>,
  }

}

function LineBlock({ id, img, headline, body, invertColors, language, displayReadMore, readMoreLink, buttonTxt, maxHeight }) {
  return (
    <Row style={{ backgroundColor: '#fff', color: '#000', padding: '50px 0 100px' }}>
      <Col className="methodology_lineblock_desktop" sm={24} md={{ span: 16, offset: 4 }}>
        <Row>
          <Col
            sm={24}
            md={{ span: 24 }}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'left',
              padding: '20px 0',
            }}
          >
            <div style={{ position: 'relative', width: '100%' }}>
              <div style={{
                position: 'absolute',
                backgroundColor: '#1abc9c',
                height: '250px',
                width: '100%',
                borderRadius: '125px 0 0 125px',
                top: '25px',
                paddingLeft: '320px',
                paddingRight: '25px',
                display: 'flex',
                alignItems: 'center',
                color: '#fff',
                textAlign: 'left',
              }}
              >
                {intl.block1[language]}
              </div>
              <div
                style={{
                  height: '300px',
                  width: '300px',
                  borderRadius: '50%',
                  background: `url(${image1}) no-repeat center center`,
                  backgroundSize: 'cover',
                  position: 'relative',
                  zIndex: '1',
                }}
              />
            </div>
          </Col>
        </Row>
      </Col>
      <Col className="methodology_lineblock_desktop" sm={24} md={{ span: 16, offset: 4 }}>
        <Row>
          <Col
            sm={24}
            md={{ span: 24 }}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'left',
              padding: '20px 0',
            }}
          >
            <div style={{ position: 'relative', width: '100%' }}>
              <div style={{
                position: 'absolute',
                backgroundColor: '#1abc9c',
                height: '250px',
                width: '100%',
                borderRadius: '0 125px 125px 0',
                top: '25px',
                paddingLeft: '25px',
                paddingRight: '320px',
                display: 'flex',
                alignItems: 'center',
                color: '#fff',
                textAlign: 'left',
              }}
              >
                {intl.block2[language]}
              </div>
              <div
                style={{
                  height: '300px',
                  width: '300px',
                  borderRadius: '50%',
                  background: `url(${image2}) no-repeat center center`,
                  backgroundSize: 'cover',
                  position: 'relative',
                  float: 'right',
                  zIndex: '1',
                }}
              />
            </div>
          </Col>
        </Row>
      </Col>
      <Col className="methodology_lineblock_desktop" sm={24} md={{ span: 16, offset: 4 }}>
        <Row>
          <Col
            sm={24}
            md={{ span: 24 }}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'left',
              padding: '20px 0',
            }}
          >
            <div style={{ position: 'relative', width: '100%' }}>
              <div style={{
                position: 'absolute',
                backgroundColor: '#1abc9c',
                height: '250px',
                width: '100%',
                borderRadius: '125px 0 0 125px',
                top: '25px',
                paddingLeft: '320px',
                paddingRight: '25px',
                display: 'flex',
                alignItems: 'center',
                color: '#fff',
                textAlign: 'left',
              }}
              >
                {intl.block3[language]}
              </div>
              <div
                style={{
                  height: '300px',
                  width: '300px',
                  borderRadius: '50%',
                  background: `url(${image3}) no-repeat center center`,
                  backgroundSize: 'cover',
                  position: 'relative',
                  zIndex: '1',
                }}
              />
            </div>
          </Col>
        </Row>
      </Col>
      {/* MOBILE VERSION */}
      <Col className="methodology_lineblock_mobile" sm={24} md={{ span: 16, offset: 4 }}>
        <Row>
          <Col
            sm={24}
            md={{ span: 24 }}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '20px 0',
              textAlign: 'center',
            }}
          >
            <div>
              <div
                style={{
                  height: '300px',
                  width: '300px',
                  borderRadius: '50%',
                  background: `url(${image1}) no-repeat center center`,
                  backgroundSize: 'cover',
                  position: 'relative',
                  zIndex: '1',
                  margin: '0 auto',
                }}
              />
              <div style={{ position: 'relative', width: '100%' }}>
                <div style={{
                  backgroundColor: '#1abc9c',
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  color: '#fff',
                  textAlign: 'center',
                  marginTop: '-100px',
                  paddingTop: '150px',
                  paddingBottom: '50px',
                }}
                >
                  {intl.block1[language]}
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Col>
      <Col className="methodology_lineblock_mobile" sm={24} md={{ span: 16, offset: 4 }}>
        <Row>
          <Col
            sm={24}
            md={{ span: 24 }}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '20px 0',
            }}
          >
            <div style={{ position: 'relative', width: '100%' }}>
              <div
                style={{
                  height: '300px',
                  width: '300px',
                  borderRadius: '50%',
                  background: `url(${image2}) no-repeat center center`,
                  backgroundSize: 'cover',
                  position: 'relative',
                  zIndex: '1',
                  margin: '0 auto',
                }}
              />
              <div style={{
                backgroundColor: '#1abc9c',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                color: '#fff',
                textAlign: 'center',
                marginTop: '-100px',
                paddingTop: '150px',
                paddingBottom: '50px',
              }}
              >
                {intl.block2[language]}
              </div>
            </div>
          </Col>
        </Row>
      </Col>
      <Col className="methodology_lineblock_mobile" sm={24} md={{ span: 16, offset: 4 }}>
        <Row>
          <Col
            sm={24}
            md={{ span: 24 }}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '20px 0',
            }}
          >
            <div style={{ position: 'relative', width: '100%' }}>
              <div
                style={{
                  height: '300px',
                  width: '300px',
                  borderRadius: '50%',
                  background: `url(${image3}) no-repeat center center`,
                  backgroundSize: 'cover',
                  position: 'relative',
                  zIndex: '1',
                  margin: '0 auto',
                }}
              />
              <div style={{
                backgroundColor: '#1abc9c',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                color: '#fff',
                textAlign: 'center',
                marginTop: '-100px',
                paddingTop: '150px',
                paddingBottom: '50px',
              }}
              >
                {intl.block3[language]}
              </div>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default LineBlock;

LineBlock.defaultProps = {
  headline: 'Headline about something?',
  body: 'iLead is the blalbalbl balbl ab blablalbalb labla',
  img: image1,
  displayReadMore: false,
};



// WEBPACK FOOTER //
// ./src/pages/Methodology/LineBlock.js